import React, { useState } from "react";
import LayerPicker from "./UIComponents/LayerPick/LayerPicker";
import Layer from "./UIComponents/LayerPick/Layer";
import Fredningszoner from "./Features/Fredningszoner";
import CertificeretOvernatning from "./Features/CertificeretOvernatning";
import Parking from "./Features/Parking";
import Fiskelinjer from "./Features/Fiskelinjer";
import BoatRentals from "./Features/BoatRentals";
import LocationMarker from "./UIComponents/LocationMaker";

import Fiskespots from "./Features/Fiskespots";
import Shelters from "./Features/Shelters";
import Shops from "./Features/Shops";
import TouristOffices from "./Features/TouristOffices";
import Creeks from "./Features/Creeks";
import FishingGuides from "./Features/FishingGuides";
import AreaVideos from "./Features/AreaVideos";

const labels = {
  spots: {
    da: "Fiskepladser",
    en: "Fishingsspots",
    de: "Angeln Spots",
  },
  accomodation: {
    da: "Overnatning",
    en: "Accommodation",
    de: "Unterkunft",
  },
  boatRental: {
    da: "Bådudlejning",
    en: "Boat rentals",
    de: "Bootsverleih",
  },
  gearShops: {
    da: "Grejbutikker",
    en: "Angling shops",
    de: "Angeln Shops",
  },
  shelters: {
    da: "Lejrpladser",
    en: "Shelters",
    de: "Schutzhütten",
  },
  touristOffices: {
    da: "Turistbureau",
    en: "Touristoffice",
    de: "Touristenbüros",
  },
  guides: {
    da: "Fiskeguider",
    en: "Fishing guides",
    de: "Angeln Guides",
  },
  streams: {
    da: "Vandløb",
    en: "Streams",
    de: "Flieβgewässer",
  },
};

/*
 * This component is responsible for displaying the different layers on the map depending on the the current state of the application
 */

const MapLayers = (props) => {
  const [showSpots, setShowSpots] = useState(true);
  const [showHotels, setShowHotels] = useState(false);
  const [showBoats, setShowBoats] = useState(false);
  const [showCamps, setShowCamps] = useState(false);
  const [showShops, setShowShops] = useState(false);
  const [showGuides, setShowGuides] = useState(false);
  const [showTourists, setShowTourists] = useState(false);

  return (
    <div>
      <LayerPicker>
        <div style={{ display: props.display || "none" }}>
          <Layer
            className="layerPicker"
            text={labels.spots[props.language]}
            icon={labels.spots.da}
            active={showSpots}
            onClick={() => setShowSpots(!showSpots)}
          />
          <Layer
            className="layerPicker"
            text={labels.accomodation[props.language]}
            icon={labels.accomodation.da}
            active={showHotels}
            onClick={() => setShowHotels(!showHotels)}
          />
          <Layer
            className="layerPicker"
            text={labels.boatRental[props.language]}
            icon={labels.boatRental.da}
            active={showBoats}
            onClick={() => setShowBoats(!showBoats)}
          />
          <Layer
            className="layerPicker"
            text={labels.gearShops[props.language]}
            icon={labels.gearShops.da}
            active={showShops}
            onClick={() => setShowShops(!showShops)}
          />
          <Layer
            className="layerPicker"
            text={labels.shelters[props.language]}
            icon={labels.shelters.da}
            active={showCamps}
            onClick={() => setShowCamps(!showCamps)}
          />
          <Layer
            className="layerPicker"
            text={labels.touristOffices[props.language]}
            icon={labels.touristOffices.da}
            active={showTourists}
            onClick={() => setShowTourists(!showTourists)}
          />
          <Layer
            className="layerPicker"
            text={labels.guides[props.language]}
            icon={labels.guides.da}
            active={showGuides}
            onClick={() => setShowGuides((p) => !p)}
          />
        </div>
      </LayerPicker>
      {showGuides && (
        <FishingGuides
          onClick={(data) => {
            props.openSidebar("guides", data);
          }}
        />
      )}

      {showSpots && (
        <Fiskespots
          onClick={props.selectSpot}
          filteredSpots={props.filteredSpots || []}
          language={props.language}
          futureDate={props.futureDate}
        />
      )}
      {props.showAreaVideos && (
        <AreaVideos
          onClick={(data) => {
            props.openSidebar("areaVideo", data);
          }}
        />
      )}
      {props.showLines && <Fiskelinjer language={props.language} />}
      {props.showFredning && <Fredningszoner language={props.language} />}
      {props.showParking && <Parking spots={props.spots} />}
      {props.yourLocation && (
        <LocationMarker
          yourLocation={props.yourLocation}
          language={props.language}
        />
      )}

      {showHotels && (
        <CertificeretOvernatning
          onClick={(data) => props.openSidebar("accommodation", data)}
          language={props.language}
        />
      )}
      {showBoats && (
        <BoatRentals
          onClick={(data) => props.openSidebar("boatRental", data)}
          language={props.language}
        />
      )}
      {showCamps && <Shelters language={props.language} />}
      {showShops && (
        <Shops
          onClick={(data) => props.openSidebar("shops", data)}
          language={props.language}
        />
      )}
      {showTourists && (
        <TouristOffices
          language={props.language}
          onClick={(feature) => props.openSidebar("touristOffices", feature)}
        />
      )}
      {props.showCreeks && (
        <Creeks
          language={props.language}
          onClick={(feature) => props.openSidebar("creeks", feature)}
        />
      )}
    </div>
  );
};

export default MapLayers;
